import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Container, Form, Row, Col } from 'react-bootstrap';
import SvgIcon from '@material-ui/core/SvgIcon';
import moment from 'moment';
import BackNext from '../../Common/SubComponents/BackNext';
import Lock from '../icons/watch.svg';
import { customValidators, object, string, date, array as yuparray } from '../../../Helpers/Validators/customValidators';
import { NEW_YORK } from '../../../Helpers/Constants/States';
import ChildInfoForm from './ChildInfoForm';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.js';
import { SelectInput } from '../../../Helpers/Inputs';

export default function ChildInfo(props) {
    const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
        validationSchema: ChildInfo.ValidationSchema(),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const childList = [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
    ];

    const state = props.basicInfo.state;

    const submitForm = () => {
        props.onNext();
    };

    useEffect(() => {
        register({ name: 'noOfDependentChildren' });
        setValue('noOfDependentChildren', props.formState.noOfDependentChildren);

        props.formState.dependentChild.forEach((child, index) => {
            register({ name: `dependentChild[${index}].firstName` });
            setValue(`dependentChild[${index}].firstName`, child.firstName);

            register({ name: `dependentChild[${index}].middleInitial` });
            setValue(`dependentChild[${index}].middleInitial`, child.middleInitial);

            register({ name: `dependentChild[${index}].lastName` });
            setValue(`dependentChild[${index}].lastName`, child.lastName);

            register({ name: `dependentChild[${index}].dateOfBirth` });
            setValue(`dependentChild[${index}].dateOfBirth`, child.dateOfBirth);

            register({ name: `dependentChild[${index}].gender` });
            setValue(`dependentChild[${index}].gender`, child.gender);
        });
    });

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    const forms = props.formState.dependentChild.map((dependentChildFormState, index) => (
        <ChildInfoForm
            formState={dependentChildFormState}
            onRemove={() => {
                props.onFieldChange(
                    'dependentChild',
                    props.formState.dependentChild.filter((form, formIndex) => formIndex !== index)
                );
                reset();
            }}
            onChange={(newForm) => {
                props.onFieldChange(
                    'dependentChild',
                    props.formState.dependentChild.map((form, formIndex) => {
                        return formIndex === index ? newForm : form;
                    })
                );
            }}
            setValue={setValue}
            trigger={triggerValidation}
            key={index}
            index={index}
            register={register}
            showChildRemove={index !== 0}
            errors={errors.dependentChild && errors.dependentChild[index]}
        />
    ));

    useEffect(() => {
        const noofdependentChild = props.formState.noOfDependentChildren;
        const noOfForms = props.formState.dependentChild.length;
        let data = []
        if (noofdependentChild > 0) {
            if (noOfForms > noofdependentChild) {

                let nullForms = props.formState.dependentChild.map((dependentChildFormState, index) => {
                    if (Object.values(dependentChildFormState).every(field => field === '')) {
                        return index;
                    }
                });

                if (nullForms.length > 0) {
                    nullForms = nullForms.filter((index) => index !== undefined);
                }
                for (let i = 0; i < noOfForms - noofdependentChild; i++) {
                    if (i < nullForms.length) {
                        data.push(nullForms[i])
                    }
                }
                let notNullForms = props.formState.dependentChild.filter((form, index) => !nullForms.includes(index));

                if (noOfForms - noofdependentChild > nullForms.length) {
                    const removeForm = noOfForms - noofdependentChild - nullForms.length;
                    notNullForms.splice(notNullForms.length - removeForm, removeForm)
                    props.onFieldChange('dependentChild', [...notNullForms]);
                    reset();
                } else {
                    props.onFieldChange('dependentChild', props.formState.dependentChild.filter((form, index) => !nullForms.includes(index)));
                    reset();
                }
            } else {
                addDependentChild(noofdependentChild - 1);
            }
        }
    }, [props.formState.noOfDependentChildren])

    const handleForm = (no) => {
        props.formState.noOfDependentChildren = no
    }

    const addDependentChild = (no) => {
        let newForm = [];
        for (let i = props.formState.dependentChild.length; i <= no; i++) {
            register({ name: `dependentChild[${i}].firstName` });
            register({ name: `dependentChild[${i}].middleInitial` });
            register({ name: `dependentChild[${i}].lastName` });
            register({ name: `dependentChild[${i}].dateOfBirth` });
            register({ name: `dependentChild[${i}].gender` });

            newForm.push({ firstName: "", middleInitial: "", lastName: "", dateOfBirth: "", gender: "" });
        }
        props.onFieldChange('dependentChild', [...props.formState.dependentChild, ...newForm]);
    };
    return (
        <Container fluid className='border-class '>
            <form onSubmit={handleSubmit(submitForm)}>
                {state === NEW_YORK ? (
                    <Fragment>
                        {' '}
                        <Row className="dependentChlidInfo justify-content-center">
                            <Col lg={5}>
                                <div className="">
                                    <Row className="justify-content-center mt-4">
                                        <Col lg={12}>
                                            <div className="text-center mb-2 pt-4">
                                                <SvgIcon component={Lock} className="small-icons" color="primary" fontSize="large" />
                                            </div>
                                            <div className="text-center mb-4 form-title">Your Child’s Information</div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <SelectInput
                                                    name="noOfDependentChildren"
                                                    id="noOfDependentChildren"
                                                    value={props.formState.noOfDependentChildren}
                                                    onChange={(e) => {
                                                        handleValueChange('noOfDependentChildren', e.target.value)
                                                        handleForm(e.target.value)
                                                    }}
                                                    label="Number of Dependent Children"
                                                    selectOptions={childList}
                                                    hideEmptyOption={true}
                                                    errors={errors && errors.noOfDependentChildren}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>{forms}</Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>{' '}
                    </Fragment>
                ) : null}
                <div className='backnext-wrapper'>
                    <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                </div>
            </form>
        </Container>
    );
}

ChildInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

ChildInfo.ValidationSchema = (ageSpecs) =>
    object().shape({
        noOfDependentChildren: string().required('Field is required.'),
        dependentChild: yuparray(
            object().shape({
                firstName: customValidators.string().isValidNameWithFiftyChar('First name is required.', true),

                middleInitial: customValidators.string().isValidNameWithFiftyChar('Middle Initials is required', true),

                lastName: customValidators.string().isValidNameWithFiftyChar('Last name is required.', true),

                gender: string().required('Gender is required.'),

                dateOfBirth: date().transform(emptyStringToUndefined).typeError('Invalid date.').max(moment(new Date()), 'Cannot be in future.').required("Date of Birth is required."),
            })
        ),
    });

ChildInfo.DefaultFormState = (prefill = false) => {
    return {
        noOfDependentChildren: 1,
        dependentChild: [
            {
                firstName: prefill ? 'Proposed' : '',
                middleInitial: prefill ? 'N' : '',
                lastName: prefill ? 'Sured' : '',
                dateOfBirth: prefill ? '11/15/1970' : '',
                gender: prefill ? 'F' : '',
            },
        ],
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/ChildInfo.js